import { MdFavoriteBorder } from "react-icons/md";
import { MdOutlineBookmarkBorder } from "react-icons/md";
import { IoBagOutline } from "react-icons/io5";
import { PiNumberFiveFill } from "react-icons/pi";
import { GoPerson } from "react-icons/go";
import { LiaAddressCardSolid } from "react-icons/lia";
import { MdPayment } from "react-icons/md";
import { CiLogout } from "react-icons/ci";
import { FaRegEdit } from "react-icons/fa";
import { useAuth } from "../context/AuthProvider";
import { useState } from "react";
import { getCustomerToken, updateCustomer } from "../apis/authApi";
import toast from "react-hot-toast";
import { TbTrash } from "react-icons/tb";

const Address = () => {

  const {user} = useAuth()

  const [addresses,setAddresses] = useState(user?.addresses||[])

  const [address,setAddress] = useState({
    street:"",
    city : "",
    state :"",
    pincode :""
  })

  const  handleChange = (e)=>{
    const {name,value} = e.target
    setAddress({...address,[name]:value})
  }

  const handleRemove = (id)=>{
    const data = addresses.filter(p=>p._id!==id)
     updateCustomer(user?._id,{addresses:data}).then(res=>{
      toast.success("Address removed successfully")
      getCustomerToken().then(res=>{
      setAddresses(res.data.addresses)}).catch(err=>console.log(err))
    }).catch(err=>{
      toast.error(err?.response?.data?.message)
    })
  }
  const handleSubmit = ()=>{
    updateCustomer(user?._id,{addresses:[...addresses,address]}).then(res=>{
      toast.success(res.message)
      setAddress({
        street:"",
        city:"",
        state:"",
        pincode:""
      })
      getCustomerToken().then(res=>{
      setAddresses(res.data.addresses)}).catch(err=>console.log(err))
    }).catch(err=>{
      toast.error(err?.response?.data?.message)
      console.log(err)
    })
  }

  return (
    <div className="">
      <div className=" p-5 bg-gray-200">
        <div className=" flex justify-between">
          <h1 className=" text-lg font-bold ">My Address</h1>
          <div className=" flex justify-end text-sm font-medium  text-gray-500 ">
            <span className=" hover:text-black cursor-pointer">Home</span>/
            <span>My address</span>
          </div>
        </div>
      </div>
      <div className="flex-row flex md:flex gap-5 justify-center mx-auto  p-10">
        <div className=" flex flex-col ">
          <div className="flex-col flex md:flex-row  items-center gap-5">
            {addresses?.map((address, index) => (
              <div key={index} className="w-[320px] h-[250px] md:w-[420px] md:h-[250px] border border-gray-300 mt-5 ">
                <div className="  border-b-2">
                  <div className=" p-5 flex justify-between items-center">
                    <span className=" text-xs md:text-black font-bold md:text-sm ">
                      Billing Address
                    </span>
                    <div className="w-[25px] h-[25px] bg-primary text-white flex items-center justify-center " onClick={()=>handleRemove(address._id)}>
                      {/* <FaRegEdit fontSize={15} /> */}
                      <TbTrash/>
                    </div>
                  </div>
                </div>
                <div className=" p-5 text-gray-600 font-semibold">
                  {/* <h4 className="sm:text-xs mt-1 ">EDWARD JOE</h4> */}
                  <div className=" mt-1">
                    <p className="sm:text-xs">{address.street}</p>
                  </div>
                  <div className=" mt-1">
                    <span className="sm:text-xs">{address.city}</span>
                  </div>
                  <div className=" mt-1">
                    <span className="sm:text-xs">{address.state}</span>
                  </div>
                  <div className=" mt-1">
                    <span className="sm:text-xs">{address.pincode}</span>
                  </div>
                </div>
              </div>
            ))}

            {/* <div className="w-[320px] h-[250px] md:w-[420px] md:h-[250px] border border-gray-300 mt-5 ">
              <div className="  border-b-2">
                <div className=" p-5 flex justify-between items-center">
                  <span className=" text-xs md:text-black font-bold md:text-sm ">
                    Billing Address
                  </span>
                  <div className="w-[25px] h-[25px] bg-primary text-white flex items-center justify-center ">
                    <FaRegEdit fontSize={15} />
                  </div>
                </div>
              </div>
              <div className=" p-5 text-gray-600 font-semibold">
                <h4 className="sm:text-xs mt-1 ">EDWARD JOE</h4>
                <div className=" mt-1">
                  <p className="sm:text-xs">301 The Greenhouse London,</p>
                </div>
                <div className=" mt-1">
                  <span className="sm:text-xs">E2 8DY UK</span>
                </div>
                <div className=" mt-1">
                  <span className="sm:text-xs">United Kingdom</span>
                </div>
                <div className=" mt-1">
                  <span className="sm:text-xs">(0123)-456789</span>
                </div>
              </div>
            </div> */}
          </div>
          <div className=" border border-gray-300 w-full  mt-10 ">
            <div className=" p-5 text-sm font-bold border-b-2">
              <h3>Add New Address</h3>
            </div>
            <div className=" flex flex-wrap gap-5  p-5">
              <div className=" w-[400px]">
                <label className=" block mb-1">Street</label>
                <input
                  className=" border border-gray-300  p-3 w-full"
                  type="text"
                  placeholder=""
                  name="street"
                  value={address.street}
                  onChange={handleChange}
                />
              </div>

              <div className=" w-[400px]">
                <label className=" block mb-1">City</label>
                <input
                  className=" border border-gray-300  p-3 w-full"
                  type="text"
                  placeholder=""
                  name="city"
                  value={address.city}
                  onChange={handleChange}
                />
              </div>
              <div className=" w-[400px]">
                <label className=" block mb-1">State</label>
                <input
                  className=" border border-gray-300  p-3 w-full"
                  type="text"
                  placeholder=""
                  name="state"
                  value={address.state}
                  onChange={handleChange}
                />
              </div>

              <div className=" w-[400px]">
                <label className=" block mb-1">Pincode</label>
                <input
                  className=" border border-gray-300  p-3 w-full"
                  type="text"
                  placeholder=""
                  name="pincode"
                  value={address.pincode}
                  onChange={handleChange}
                />
              </div>
            </div>
            {/* <div className="p-5 gap-2 flex items-center">
              <input type="checkbox" className="accent-red-500 w-4 h-4" />
              <span className="text-sm text-gray-600">
                Make this address primary
              </span>
            </div> */}
            <div className=" p-5">
              <button
                className=" bg-primary text-white px-5 py-2 text-sm"
                onClick={handleSubmit}
              >
                Add New Address
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Address;
